module.exports = __webpack_public_path__ + "ecdc5d7616d665168c6f9596bb4826f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_descriptions_show.png
// module id = 63
// module chunks = 0 1 2 3 4